<script setup lang="ts">
import { formatCurrency } from "shared/helpers";

import { getProductDefault } from "~/common/defaults/product.default";
import { getItemMinPrice } from "~/common/helpers/get-item-min-price";
import type { ShopProductsResponseDto } from "~/common/interfaces/dto/shop/shop-products-response.dto";
import { useShopStore } from "~/stores/shop";

const shopStore = useShopStore();

const props = defineProps({
	item: {
		type: Object as PropType<ShopProductsResponseDto>,
		default () {
			return getProductDefault();
		}
	}
});
defineEmits(["click"]);

const minItemPrice = getItemMinPrice(shopStore.components?.pricePolicies, props.item);
</script>

<template>
	<article
		class="group cursor-pointer"
		tabindex="0"
		role="link"
		aria-label="Item details"
	>
		<CommonSwiper
			:image-ids="item.imageIds"
			:image-size="{width: 328, height: 437}"
			:tags="item.tags"
			@click:nested="$emit('click')"
		/>
		<div class="mt-3" @click="$emit('click')">
			<span class="text-green-dark text-sm">
				{{ item.kind.name }}
			</span>
			<header class="group-hover:underline underline-offset-8">
				<h2>
					{{ item.name }}
				</h2>
			</header>
			<p v-if="minItemPrice" class="mt-3 flex gap-x-2">
				{{ formatCurrency(minItemPrice) }}
			</p>
		</div>
	</article>
</template>
